if (!customElements.get('membership-product')) {
  class membershipProduct extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.select = this.querySelector('[data-main-select]');
      this.button = this.querySelector('[data-action="add-to-cart"]');
      this.radios = this.querySelectorAll('input[type="radio"]');
      this.optionSelects = this.querySelectorAll('[data-option-select]');
      this.sellingPlanInput = this.form.querySelector('#sellingPlan');

      this.radios.forEach(radio => {
        radio.addEventListener('change', () => this.onOptionChange());
      });

      this.optionSelects.forEach(select => {
        select.addEventListener('change', () => this.onOptionChange());
      });

      this.select.addEventListener('change', () => {
        this.updateButtonState();
      });

      this.onOptionChange();
      this.applyUtmPersonalization();
    }

    applyUtmPersonalization() {
      const rawParams = this.dataset.utmParams;
      if (!rawParams) return;

      const watchList = rawParams.split(',').map(s => s.trim()).filter(Boolean);
      if (!watchList.length) return;

      const urlParams = new URLSearchParams(window.location.search);

      let matchedParam = null;
      for (const paramString of watchList) {
        const eqIndex = paramString.indexOf('=');
        if (eqIndex === -1) continue;
        const key = paramString.slice(0, eqIndex);
        const value = paramString.slice(eqIndex + 1);
        if (urlParams.get(key) === value) {
          matchedParam = paramString;
          break;
        }
      }

      if (!matchedParam) return;

      const defaultGallery = this.querySelector('[data-default-gallery]');
      const utmGallery = this.querySelector(`[data-utm-gallery][data-utm-param="${CSS.escape(matchedParam)}"]`);

      if (defaultGallery && utmGallery) {
        defaultGallery.style.display = 'none';
        utmGallery.style.removeProperty('display');

        requestAnimationFrame(() => {
          utmGallery.querySelectorAll('[data-utm-thumbs-gallery], [data-utm-desktop-thumbs-gallery]').forEach(el => el.initialize());
          requestAnimationFrame(() => {
            utmGallery.querySelectorAll('swiper-container:not([data-utm-thumbs-gallery]):not([data-utm-desktop-thumbs-gallery])').forEach(el => el.initialize());
          });
        });
      }

      const descEl = this.querySelector('[data-product-description]');
      const utmDescEl = this.querySelector(`[data-utm-description][data-utm-param="${CSS.escape(matchedParam)}"]`);
      if (descEl && utmDescEl) {
        descEl.innerHTML = utmDescEl.innerHTML;
      }
    }

    getSelectedOptions() {
      const options = {};

      this.radios.forEach(radio => {
        if (radio.checked) {
          options[radio.name] = radio.value;
        }
      });

      this.optionSelects.forEach(select => {
        options[select.name] = select.value;
      });

      return options;
    }

    onOptionChange() {
      const selectedOptions = this.getSelectedOptions();
      const selectedValues = Object.values(selectedOptions);

      // Update selling plan from checked radio
      const checkedRadio = Array.from(this.radios).find(r => r.checked && r.dataset.sellingPlan);
      if (checkedRadio && this.sellingPlanInput) {
        const sellingPlanId = checkedRadio.dataset.sellingPlan;
        if (sellingPlanId) {
          this.sellingPlanInput.value = sellingPlanId;
          this.sellingPlanInput.disabled = false;
        }
      }

      // Find variant matching all selected option values
      const match = Array.from(this.select.options).find(option => {
        const parts = option.textContent.trim().split(/\s*\/\s*/);
        return selectedValues.every(val => parts.includes(val));
      });

      if (!match) return;

      this.select.value = match.value;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));

      const url = new URL(window.location);
      url.searchParams.set('variant', match.value);
      window.history.replaceState({}, '', url);
    }

    updateButtonState() {
      const option = this.select.selectedOptions[0];
      const available = option && option.dataset.available === 'true';

      this.button.disabled = !available;
      this.button.textContent = available
        ? window.theme?.strings?.addToCart || 'Add to cart'
        : window.theme?.strings?.unavailable || 'Unavailable';
    }
  }

  customElements.define('membership-product', membershipProduct);
}
